/**
 * @generated SignedSource<<eee73c796ba15cdc8fe43460b064e46f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoreSurveysBanner_profileUrlRef$data = {
  readonly endlessProfilerUrl: string | null;
  readonly " $fragmentType": "MoreSurveysBanner_profileUrlRef";
};
export type MoreSurveysBanner_profileUrlRef$key = {
  readonly " $data"?: MoreSurveysBanner_profileUrlRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoreSurveysBanner_profileUrlRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoreSurveysBanner_profileUrlRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endlessProfilerUrl",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a2e49d257deeeb3175bfc26c3651a589";

export default node;
